import { defineMessages } from 'react-intl'

export const teamPageMessages = defineMessages({
  usersLabel: {
    id: 'teamPage.usersLabel',
    description: 'Users label for counter on Team page',
    defaultMessage: 'users',
  },
  searchPlaceholder: {
    id: 'teamPage.searchPlaceholder',
    description: 'Common search placeholder on Team page',
    defaultMessage: 'Search team member in selected group…',
  },
  noUsersFoundMessage: {
    id: 'teamPage.noUsersFoundMessage',
    description: 'No users found message on Team page',
    defaultMessage: 'No users found',
  },
  addUserButtonLabel: {
    id: 'teamPage.addUserButtonLabel',
    description: 'add User Button label on Team page',
    defaultMessage: 'Add User',
  },
  successModalMessage: {
    id: 'teamPage.successModalMessage',
    description: 'Success Modal Message after Add User operation on Team page',
    defaultMessage: '{email} has been added to {selectedDomainName}',
  },
  nameColumn: {
    id: 'teamPage.nameColumn',
    description: 'Label for table column "name" on Team page',
    defaultMessage: 'Name',
  },
  emailColumn: {
    id: 'teamPage.emailColumn',
    description: 'Label for table column "email" on Team page',
    defaultMessage: 'Email',
  },
  adminColumn: {
    id: 'teamPage.adminColumn',
    description: 'Label for table column "admin" on Team page',
    defaultMessage: 'Admin',
  },
  configColumn: {
    id: 'teamPage.configColumn',
    description: 'Label for table column "config" on Team page',
    defaultMessage: 'Config',
  },
  subscriptionManagementColumn: {
    id: 'teamPage.subscriptionManagementColumn',
    description:
      'Label for table column "Subscription Management" on Team page',
    defaultMessage: 'Subscription Management',
  },
  avatarImageAlt: {
    id: 'teamPage.avatarImageAlt',
    description: 'User avatar image alt on Team page',
    defaultMessage: 'User avatar',
  },
  permissionsErrorTitle: {
    id: 'teamPage.permissionsErrorTitle',
    description: 'Permissions error title for popup on Team page',
    defaultMessage: 'User Permissions Error',
  },
  permissionsUpdateError: {
    id: 'teamPage.permissionsUpdateError',
    description: 'Permissions update error message on Team page',
    defaultMessage: "Can't update user permissions",
  },
  unknownPermissionsUpdateError: {
    id: 'teamPage.unknownPermissionsUpdateError',
    description: 'Unknown permissions update error message on Team page',
    defaultMessage: 'Not enough permissions or something went wrong',
  },
  removeUserPopupTitle: {
    id: 'teamPage.removeUserPopupTitle',
    description: 'Remove User title for popup on Team page',
    defaultMessage: 'Remove user',
  },
  removeUserPopupDesc: {
    id: 'teamPage.removeUserPopupDesc',
    description: 'Remove User description for popup on Team page',
    defaultMessage:
      'Remove {email} from this group? {br} This action will not remove their access from the Savant Store or Community.',
  },
})
